export default __webpack_public_path__ + "static/media/list_01_img.999105ca.png";